import type { MediaPreset, MediaView, Delivery } from "./mediaTypes";
export const MEDIA_WIDTHS: Record<MediaPreset, number> = {
  THUMBNAIL: 320, PRODUCT_CARD: 480, CATALOGUE: 800, PRODUCT_DETAIL: 1200, ZOOM: 2000,
};
export function safeDeliveryUrl(raw: string | null | undefined): string | undefined {
  if (!raw) return undefined;
  try {
    const url = new URL(raw);
    if (url.protocol !== "https:" && url.protocol !== "http:") return undefined;
    if (decodeURIComponent(url.pathname).split("/").includes("original")) return undefined;
    return raw;
  } catch { return undefined; }
}
export function servableCopyCount(media: { derivatives?: { url: string }[] } | undefined): number {
  return (media?.derivatives || []).filter(image => Boolean(safeDeliveryUrl(image.url))).length;
}

/** Temporary confirmation. Remove with the original-archive notice. */
export function savedMediaNotice(copies: number): string {
  if (copies > 1) return `Original saved and ${copies} servable copies made.`;
  if (copies === 1) return "Original saved and 1 servable copy made.";
  return "Original saved. Servable copies are still being made.";
}

export const savedMediaCopiesMissing = "Original saved. Servable copies were not created.";

export function deliveryFor(media: MediaView | undefined, preset: MediaPreset): Delivery | undefined {
  const entries = (media?.derivatives || []).filter(image => Boolean(safeDeliveryUrl(image.url)));
  return entries.find(image => image.preset === preset)
    || entries.filter(image => image.width >= MEDIA_WIDTHS[preset]).sort((a, b) => a.width - b.width)[0]
    || entries.sort((a, b) => b.width - a.width)[0];
}
